import { PropsWithChildren } from 'react';

// TODO: this component is not using. Can be deleted.

const DownloadHistoricalDataGateComponent = ({ children }: PropsWithChildren) => {
	return <>{children}</>;
};

export default DownloadHistoricalDataGateComponent;
